import styled from 'styled-components';
const FakeConnector = styled.div.withConfig({
  displayName: "FakeConnector",
  componentId: "sc-6nqjxm-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    width: '2px',
    height: '30px',
    background: theme.color['icon-core-subtle']
  };
});
export default FakeConnector;